import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Button, Input, Select } from '../../ui';
import Continue from '../../Common/Continue';
import iconUser from '../../../assets/icons/icon-user.svg';
import Form from './Form.styles';
import Checkbox from './Checkbox';
import { setRentalValue } from '../../../actions';
import { validateEmail, justNumbers } from '../../../helpers';

function Property(props) {
  const {
    onValueChange,
    knownRealEstate,
    knownPropertyLocation,
    knownPropertyLocationText,
    monthlyRentalAmount,
    monthlyRentalAmountCurrency,
    knowUs,
    clientEmail,
    confidenceBroker,
  } = props;

  const [validated, setValidated] = useState(false);

  useEffect(() => {
    function validatedCondition() {
      return (
        knowUs != null &&
        confidenceBroker != null &&
        monthlyRentalAmount != '' &&
        justNumbers(monthlyRentalAmount)
      );
    }

    setValidated(validatedCondition());
  }, [knowUs, clientEmail, monthlyRentalAmount, confidenceBroker]);

  return (
    <Form>
      <div className="Form-title">Inmueble</div>

      <div className="Form-row">
        <div className="Form-col" style={{ maxWidth: 500, margin: '0 auto' }}>
          <div className="Form-group" style={{ marginBottom: '2.5rem' }}>
            <div
              className="Form-label"
              style={{
                textAlign: 'left',
                fontSize: '1rem',
                marginBottom: '1rem'
              }}
            >
              ¿Conoce a la inmobiliaria con la que realizará el alquiler?
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-around'
              }}
            >
              <Checkbox
                id="knownRealEstateYes"
                onChange={() => {
                  onValueChange('knownRealEstate', true);
                }}
                checked={knownRealEstate}
                label="Si"
              />

              <Checkbox
                id="knownRealEstateNo"
                onChange={() => {
                  onValueChange('knownRealEstate', false);
                }}
                checked={!knownRealEstate}
                label="No"
              />
            </div>
          </div>

          <div className="Form-group" style={{ marginBottom: '1.5rem' }}>
            <div
              className="Form-label"
              style={{
                textAlign: 'left',
                fontSize: '1rem',
                marginBottom: '1rem'
              }}
            >
              ¿Conoce la ubicación donde tiene pensado alquilar?
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-around'
              }}
            >
              <Checkbox
                id="knownPropertyLocationYes"
                onChange={() => {
                  onValueChange('knownPropertyLocation', true);
                }}
                checked={knownPropertyLocation}
                label="Si"
              />

              <Checkbox
                id="knownPropertyLocationNo"
                onChange={() => {
                  onValueChange('knownPropertyLocation', false);
                }}
                checked={!knownPropertyLocation}
                label="No"
              />
            </div>
          </div>

          {knownPropertyLocation && (
            <div className="Form-group">
              <Input
                id="knownPropertyLocationText"
                name="knownPropertyLocationText"
                placeholder="Dirección del inmueble a alquilar (*)"
                type="text"
                leftIcon={iconUser}
                autoComplete="nope"
                value={knownPropertyLocationText}
                onChange={event => {
                  onValueChange('knownPropertyLocationText', event.target.value);
                }}
              />
            </div>
          )}

          <div className="Form-group">
            <Input
              id="monthlyRentalAmount"
              name="monthlyRentalAmount"
              placeholder="Importe de alquiler mensual (*)"
              maxLength="50"
              type="number"
              leftIcon={iconUser}
              autoComplete="nope"
              value={monthlyRentalAmount}
              onChange={event => {
                onValueChange('monthlyRentalAmount', event.target.value);
              }}
            />
          </div>

          <div
            className="Form-group"
            style={{
              display: 'flex',
              justifyContent: 'space-around',
              marginTop: '-.625rem',
              marginBottom: '1.5rem'
            }}
          >
            <Checkbox
              id="monthlyRentalAmountCurrencyPeso"
              onChange={() => {
                onValueChange('monthlyRentalAmountCurrency', false);
              }}
              checked={!monthlyRentalAmountCurrency}
              label="Pesos"
            />

            <Checkbox
              id="monthlyRentalAmountCurrencyDolar"
              onChange={() => {
                onValueChange('monthlyRentalAmountCurrency', true);
              }}
              checked={monthlyRentalAmountCurrency}
              label="Dólares"
            />
          </div>

          <div className="Form-group">
            <Select
              id="knowUs"
              name="knowUs"
              placeholder="¿Cómo nos conoció? (*)"
              options={[
                { value: 'publicidad', label: 'Publicidad' },
                { value: 'redes_sociales', label: 'Redes sociales' },
                { value: 'internet', label: 'Búsqueda en Internet' },
                { value: 'familiar_amigo', label: 'Familiar o amigo' },
                { value: 'corredore_seguros', label: 'Corredor de seguros' },
                { value: 'inmobiliaria', label: 'Inmobiliaria' },
                { value: 'otros', label: 'Otros' }
              ]}
              label="¿Cómo nos conoció?"
              leftIcon={iconUser}
              value={knowUs}
              onChange={value => {
                onValueChange('knowUs', value);
              }}
            />
          </div>

          <div className="Form-group">
            <Select
              id="confidenceBroker"
              name="confidenceBroker"
              placeholder="Corredor de confianza (*)"
              options={[
                { value: 'seguros_directos', label: 'Seguros Directos' },
                // { value: 'otro', label: 'Otro' }
              ]}
              label="Corredor de confianza"
              leftIcon={iconUser}
              value={confidenceBroker}
              onChange={value => {
                onValueChange('confidenceBroker', value);
              }}
            />
          </div>
        </div>
      </div>

      <Continue state={validated} />
    </Form>
  );
}

const mapStateToProps = state => {
  return {
    knownRealEstate: state.rental.knownRealEstate,
    knownPropertyLocation: state.rental.knownPropertyLocation,
    knownPropertyLocationText: state.rental.knownPropertyLocationText,
    monthlyRentalAmount: state.rental.monthlyRentalAmount,
    monthlyRentalAmountCurrency: state.rental.monthlyRentalAmountCurrency,
    confidenceBroker: state.rental.confidenceBroker,
    knowUs: state.rental.knowUs,
    clientEmail: state.rental.clientEmail
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onValueChange: (type, value) => {
      dispatch(setRentalValue(type, value));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Property);
